import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetRoomDirectoryActivityData, IGetRoomDirectoryActivityVars } from '../types';

export const GET_ROOM_DIRECTORY_ACTIVITY: TypedDocumentNode<
  IGetRoomDirectoryActivityData,
  IGetRoomDirectoryActivityVars
> = gql`
  query getRoomDirectoryQuery($input: RoomDirectoryActivityQueryInput!) {
    getRoomDirectoryActivity(input: $input) {
      lastName
      firstName
      username
      lastGeneratedOn
    }
  }
`;
